export default "__VITE_ASSET__dFa6kxA5__"